// extracted by mini-css-extract-plugin
export default {"container":"searchpage_container__Rbqsj","results":"searchpage_results__amxHy","message":"searchpage_message__CHfFi"};